import { render, staticRenderFns } from "./shareholderListView.vue?vue&type=template&id=b389aa70&scoped=true"
import script from "./shareholderListView.vue?vue&type=script&lang=js"
export * from "./shareholderListView.vue?vue&type=script&lang=js"
import style0 from "./shareholderListView.vue?vue&type=style&index=0&id=b389aa70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b389aa70",
  null
  
)

export default component.exports